import { render, staticRenderFns } from "./BollettazioneImporta.vue?vue&type=template&id=733b0097"
import script from "./BollettazioneImporta.vue?vue&type=script&lang=js"
export * from "./BollettazioneImporta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports